var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"db-ChromeMainContent"},[_c('div',{staticClass:"db-ChromeMainContent-content",attrs:{"tabindex":"-1"}},[_vm._v("Forms")])])}]

export { render, staticRenderFns }